import React, { useState } from "react";
import { Avatar, Button, LinearProgress } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import EmailOutlinedIcon from "@material-ui/icons/EmailOutlined";
import Typography from "@material-ui/core/Typography";
import * as Yup from "yup";
import Container from "@material-ui/core/Container";
import Copyright from "../common_components/Copyright";
import { Alert } from "@material-ui/lab";
import { TextField } from "components/common_components/Formik";
import { sendPasswordResetEmail } from "../../config/firebaseWithFirestore";
import { Formik, Form } from "formik";
import useStyles from "./useStyles";

export default function ForgotPassword({ history }) {
    const classes = useStyles();
    const [error, setError] = useState(undefined);
    const [success, setSuccess] = useState(undefined);

    function submitHandler({ email }, { setSubmitting }) {
        setSubmitting(true);
        sendPasswordResetEmail(email)
            .then((response) => {
                setSuccess(
                    "Email sent successfully. Please check your inbox. If you don't see it, please also check your unwanted or spam emails.",
                );
                setError(undefined);
                setSubmitting(false);
            })
            .catch((error) => {
                setSuccess(undefined);
                setError(error.message);
                setSubmitting(false);
            });
    }

    function onCancelHandler(resetForm) {
        resetForm();
        setError(undefined);
        setSuccess(undefined);
        history.push("/login");
    }

    const validationSchema = Yup.object({
        email: Yup.string().required("Required field").email("Incorrect email"),
    });

    return (
        <Container component="main" maxWidth="xs">
            <div className={classes.paper}>
                <Avatar className={classes.avatar}>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5" style={{ marginTop: "40px" }}>
                    Have you forgotten your password?
                </Typography>
                <Typography component="h1" variant="subtitle2" style={{ marginTop: "40px" }}>
                    Enter the email address you use to get into the application, then click on the SEND EMAIL button.
                </Typography>
                <Formik onSubmit={submitHandler} initialValues={{ email: "" }} validationSchema={validationSchema} validateOnChange={false} validateOnBlur={false}>
                    {({ isSubmitting, resetForm }) => (
                        <Form className={classes.form}>
                            <TextField
                                type="email"
                                fieldName="email"
                                variant="standard"
                                label="Email Address *"
                                disabled={isSubmitting || success}
                                autoFocus
                                lowercase
                            />
                            {!isSubmitting && !success && (
                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    color="secondary"
                                    startIcon={<EmailOutlinedIcon />}
                                    className={classes.submit}>
                                    Send Email
                                </Button>
                            )}
                            {isSubmitting && <LinearProgress className={classes.linearProgress} />}
                            {error && <Alert severity="error">{error}</Alert>}
                            {success && <Alert severity="success">{success}</Alert>}
                            <Button
                                onClick={() => onCancelHandler(resetForm)}
                                fullWidth
                                variant="text"
                                color="default"
                                title="Back to Login">
                                Back to Login
                            </Button>
                        </Form>
                    )}
                </Formik>
            </div>
            <Box mt={8}>
                <Copyright />
            </Box>
        </Container>
    );
}
